<template>
  <v-dialog
    v-model="showReportProblemDialog"
    max-width="912px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
  >
    <v-card v-if="showReportProblemDialog">
      <v-card-title class="primary white--text">
        <h3 class="headline mb-0">
          {{ $t('texts.reportError') }}
        </h3>
        <v-spacer/>
        <v-btn text small fab @click="showReportProblemDialog = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-xl class="pa-0">
          <form>
            <v-row>
              <v-col :cols="12">
                <v-text-field
                  :label="$t('texts.title')"
                  v-model="form.title"
                  required
                  :error-messages="errors.collect('title')"
                  v-validate="'required'"
                  data-vv-name="title"
                  :data-vv-as="$t('texts.title')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12">
                <v-textarea
                  :label="$t('texts.description')"
                  v-model="form.message"
                  required
                  :error-messages="errors.collect('description')"
                  v-validate="'required'"
                  data-vv-name="description"
                  :data-vv-as="$t('texts.description')"
                />
              </v-col>
            </v-row>
          </form>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-3" :class="$vuetify.breakpoint.xsOnly ? 'card__actions--mobile' : ''">
        <v-spacer/>
        <v-btn
          color="primary" class="white--text"
          @click="submit()"
        >
          {{ $t('texts.send') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapGeneralState, mapActions: mapGeneralActions } = createNamespacedHelpers('general');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'ReportProblemDialog',
  data() {
    return {
      showReportProblemDialog: false,
      form: {
        job_id: null,
        title: '',
        message: '',
      },
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  mounted() {
    this.$eventBus.$on('show-report-problem-dialog', (jobId) => {
      this.form.job_id = jobId;
      this.showReportProblemDialog = true;
    });
  },
  computed: {
    ...mapGeneralState([
      'sendProblemReportPending',
    ]),
  },
  methods: {
    ...mapGeneralActions([
      'sendProblemReport',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendProblemReport(this.form).then(() => {
            this.showReportProblemDialog = false;
          });
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
